export enum PaymentStatus {
    NotPaid = 0,
    PaidByCard = 1,
    PaidWithCash = 2
  }
  
  export const PaymentStatusLabels: Record<PaymentStatus, string> = {
    [PaymentStatus.NotPaid]: 'Not Paid',
    [PaymentStatus.PaidByCard]: 'Paid by Card',
    [PaymentStatus.PaidWithCash]: 'Paid with Cash'
  };